import React from 'react';

class Home extends React.Component {

    render() {
        return (


           
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu w40">
                    <div className="cover w40"></div>
                    <img src="img/header.png" srcSet="" className="hero-image-desktop" alt=""/>
                    <img src="img/7c9e5d0f857314f5e2aaf4d2bd27426a.png" className="cover-thumb" alt=""/>
                </div>

                <img src="img/header.png" srcSet="" className="hero-image" alt=""/>
                <div className="body-con w60">                
                    <h1 className="home"> share what <br/> you’re thankful for! </h1>
                    
                    <div className="textcon">
                        <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a clip from the upcoming "Thank You Lord" music video.</p>
                    </div>

                    < br className="hidden-mobile" />
                    <div className="listcon">
                        <div className="con">
                            <div className="step">
                                <div className="stepnumber">1</div>
                            </div>
                            <h2 className="step-title">tell us what you’re thankful for</h2>
                        </div>

                        <div className="con">
                            <div className="step">
                                <div className="stepnumber">2</div>
                            </div>
                            <h2 className="step-title"> Show what you are thankful for</h2>
                        </div>

                        <div className="con">
                            <div className="step">
                                <div className="stepnumber">3</div>
                            </div>
                            <h2 className="step-title"> get your custom music video!</h2>
                        </div>
                    </div>

               < br className="hidden-mobile" />

                    <a href="step1img">
                    <div className="next-button-con">
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">get started</div>
                                    <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div> 
        );
    }
}

export default Home;